import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  funnels: [],
  availableLabels: [], // Labels que podem ser usadas para criar/editar funis
  selectedFunnelId: null, // ID do funil ativo
  cardsByLabel: {}, // Objeto: { label_id: [card1, card2], ... }
  cardsMeta: {}, // Metadados dos cards (paginação, total, etc) por label
  loading: {
    funnels: false,
    labels: false,
    cards: false,
    create: false,
    update: false,
    delete: false,
    move: false,
  },
  error: {
    funnels: null,
    labels: null,
    cards: null,
    create: null,
    update: null,
    delete: null,
    move: null,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 